import './Testimonials.css';

const featured = {
  name: 'Sophie M.',
  role: 'Maman de Lucas, 8 ans',
  initials: 'SM',
  stars: 5,
  highlight: '3 semaines pour changer notre relation',
  quote: 'Depuis qu\'on a commencé Evolify, Lucas range sa chambre sans qu\'on lui demande et met beaucoup plus de bonne volonté à l\'accomplissement de certaines tâches quotidienne. J\'avais du mal à y croire au début. Le déclic ? Il a lui-même choisi ses tâches et adore découvrir les petites cartes. En 3 semaines, nos échanges sur ces sujets sont passés de tension permanente à beaucoup plus de sérénité. C\'est la meilleure app qu\'on ait utilisée cette année ! Je la conseille vraiment ! Merci Evo ;)',
  badge: '⭐ Coup de cœur bêta',
};

const testimonials = [
  {
    name: 'Thomas P.',
    role: 'Papa de Camille et Léo, 6 et 8 ans',
    initials: 'TP',
    color: '#10B981',
    stars: 5,
    quote: 'Le matin était une guerre (faire le lit, s\'habiller seul pour Léo, descendre à l\'heure au petit déj). Maintenant, les deux font leurs missions et arrivent à table tout seuls. Les petits messages d\'Evo à chaque validation, c\'est magique — Camille est tout sourire quand elle arrive à les lire !',
  },
  {
    name: 'Marie-Claire D.',
    role: 'Maman de Théo, 7 ans',
    initials: 'MC',
    color: '#EC4899',
    stars: 5,
    quote: 'J\'étais sceptique... encore une appli qui veut changer nos vies ? Mais là c\'est différent : c\'est l\'enfant qui est acteur. Théo est hyper fier quand il fait ses missions, il s\'est vraiment pris au jeu. Et moi j\'ai enfin arrêté de répéter les mêmes choses 10 fois et je suis vraiment fier de lui quand il réussi à faire ça en autonomie (et je le lui montre !).',
  },
  {
    name: 'Antoine R.',
    role: 'Papa de Iris, 10 ans',
    initials: 'AR',
    color: '#F59E0B',
    stars: 5,
    quote: 'On a activé le Mode Autonomie progressivement comme conseillé. Après un peu plus d\'un mois, Iris a maintenu son habitude de faire sa mission (commencer ses devoirs seule en rentrant de l\'école), et maintenant sans forcément gagner de l\'XP. C\'est exactement ce qu\'on cherchait depuis des années : une vraie autonomie, pas juste de l\'obéissance.',
  },
  {
    name: 'Nathalie B.',
    role: 'Maman de Mathis et Zoé, 7 et 11 ans',
    initials: 'NB',
    color: '#F97316',
    stars: 5,
    quote: '15 minutes pour créer les tâches avec les enfants au début, et depuis c\'est devenu une routine. Mathis et Zoé se font même "concurrence" dans la progression — ils s\'encouragent mutuellement et se rappelle même de faire certaines missions l\'un l\'autre parfois. Je n\'aurais jamais imaginé ça il y a quelques mois...',
  },
];

function Stars({ count }) {
  return (
    <div className="testi-stars" aria-label={`${count} étoiles sur 5`}>
      {Array.from({ length: 5 }, (_, i) => (
        <span key={i} className={i < count ? 'testi-star testi-star--filled' : 'testi-star'}>★</span>
      ))}
    </div>
  );
}

function Avatar({ initials }) {
  return (
    <div className="testi-avatar">
      {initials}
    </div>
  );
}

export default function Testimonials() {
  return (
    <section className="testimonials" id="temoignages">
      <div className="testimonials__bg">
        <div className="testimonials__bg-blob--1" />
        <div className="testimonials__bg-blob--2" />
      </div>

      <div className="container">
        <div className="testimonials__header">
          <div className="section-label">💬 Témoignages</div>
          <h2 className="section-title">Des familles qui ont franchi le pas</h2>
          <p className="section-subtitle">
            Plus de 50 familles testent Evolify.<p>Voici ce qu'elles vivent au quotidien.</p>
          </p>
        </div>

        {/* Featured — grand card coloré */}
        <div className="testi-featured">
          <div className="testi-featured__deco">"</div>
          <div className="testi-featured__top">
            <span className="testi-featured__badge">{featured.badge}</span>
            <Stars count={featured.stars} />
          </div>
          <blockquote className="testi-featured__quote">{featured.quote}</blockquote>
          <div className="testi-featured__highlight">
            <span>✨</span>
            {featured.highlight}
          </div>
          <div className="testi-featured__author">
            <Avatar initials={featured.initials} />
            <div className="testi-featured__author-info">
              <strong>{featured.name}</strong>
              <span>{featured.role}</span>
            </div>
          </div>
        </div>

        {/* Grille 2×2 colorée */}
        <div className="testimonials__grid">
          {testimonials.map((t, i) => (
            <div key={i} className="testi-card" style={{ '--testi-color': t.color }}>
              <div className="testi-card__top">
                <Stars count={t.stars} />
                <div className="testi-card__verified">✓ Vérifié</div>
              </div>
              <blockquote className="testi-card__quote">"{t.quote}"</blockquote>
              <div className="testi-card__author">
                <Avatar initials={t.initials} />
                <div>
                  <strong className="testi-card__name">{t.name}</strong>
                  <span className="testi-card__role">{t.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Barre de note */}
        <div className="testimonials__bar">
          <div className="testimonials__bar-rating">
            <span className="testimonials__bar-score" data-countup="4.8" data-decimal="1">4,8</span>
            <div>
              <Stars count={5} />
              <span className="testimonials__bar-label">Note moyenne sur 50+ familles bêta</span>
            </div>
          </div>
          <div className="testimonials__bar-divider" />
          <div className="testimonials__bar-stats">
            <div className="testimonials__bar-stat">
              <span>🏠</span>
              <strong data-countup="200" data-suffix="+">50+</strong>
              <span>familles actives</span>
            </div>
            <div className="testimonials__bar-stat">
              <span>📅</span>
              <strong data-countup="3" data-suffix=" sem.">3 sem.</strong>
              <span>pour voir des résultats</span>
            </div>
            <div className="testimonials__bar-stat">
              <span>❤️</span>
              <strong data-countup="94" data-suffix="%">94%</strong>
              <span>recommandent</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
